export default "__VITE_PUBLIC_ASSET__518cf164__"